import axios from '@/axios/axios2'

// 查询累计商户数
export const getCumulative = params =>
  axios.post('/statistics/getCumulative', params)

/**
 * 上传oss 参数获取
 */
export const getOssSign = data => axios.post('/common/oss/getPrivateSign', data)
/**
 * 上传oss 私有链接转换成共有
 */
export const getValidUrl = data => axios.post('/common/getValidUrl', data)
/**
 * OCR识别--身份证-new
 */
export const ocrAgentIdCard = data => axios.post('/common/idcardOcr', data)
/**
 * 保存身份证信息
 */
export const updatePartnerImage = data =>
  axios.post('/partner/updatePartnerImage', data)
/**
 * 查询签约情况
 */
export const signIndexInfo = data => axios.post('/sign/index', data)

/**
 * 保存活体人脸
 */
export const faceVerification = data =>
  axios.post('/partner/faceVerification', data)

/**
 * 发送验证码
 */
export const sendMessage = data => axios.post('/msg/sendMessage', data)
/**
 * OCR银行卡
 */
export const verifyBankCard = data =>
  axios.post('/bankCard/verifyBankCard', data)
/**
 * 绑定银行卡
 */
export const updateBankCard = data => axios.post('/sign/updateBankCard', data)
